import paymentAccounts from '@/router/routes/administration/paymentAccounts'
import faktLegalEntities from '@/router/routes/administration/faktLegalEntities'
import tariffs from '@/router/routes/administration/tariffs'
import filialConnection from '@/router/routes/administration/filialConnection'
import RouteName from '@/models/enums/RouteName'
import CRMPermission from '@/models/enums/permissions/CRMPermission'

export default [
  {
    path: '/administration',
    name: RouteName.Administration,
    component: () => import('@/pages/Administration/AdministrationPage.vue'),
    meta: {
      permissions: [CRMPermission.ViewAdministration],
      breadcrumb: {
        label: 'Администрирование',
        parent: 'Главная',
      },
    },
  },
  ...paymentAccounts,
  ...faktLegalEntities,
  ...tariffs,
  ...filialConnection,
]
